import { Add } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import { useIntl } from 'react-intl';

interface EditToolbarProps {
  onAddRow: () => void;
}

export const OperatingCostsGridToolbar = (props: EditToolbarProps) => {
  const { onAddRow } = props;
  const { formatMessage } = useIntl();
  const handleClick = () => {
    onAddRow();
  };

  return (
    <Stack>
      <Box>
      <Button color="primary" variant='text' startIcon={<Add />} onClick={handleClick}>
        {formatMessage({ id: 'Add operating cost' })}
      </Button>
      </Box>
    </Stack>
  );
};